import React, { useEffect, useState, useRef } from 'react';
import { Box, Title, SubTitle, Text, Button, Space, CalendarItem,  LookupResponsiveimage } from '../theme/theme';
import MetaTags from 'react-meta-tags';
import { useSelector } from 'react-redux';
import Spinner from '../components/spinner';
import { Container, Grid, ImageList, Typography } from '@mui/material';
import BlockContent from '@sanity/block-content-to-react'

import settings from "../settings.json"
import { Link } from 'react-router-dom';
import { AvatarList } from '../components/avatar';
import { Subtitles } from '@mui/icons-material';

import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Masonry from '@mui/lab/Masonry';
import Paper from '@mui/material/Paper';
import ReactDOM from 'react-dom';

import CollapsibleContainer from '../components/collapsibleContainer';
import GridLayout from "react-grid-layout";
import { Responsive as ResponsiveGridLayout } from "react-grid-layout";
import Info from '../dashboarders/Info';
import Settings from '../dashboarders/settings';
import TwoD from '../dashboarders/twoD';
import ThreeD from '../dashboarders/threeD';
import CustomDashboard from '../components/customDashboard';



const Home = ()=>{

    const Meta = <MetaTags>
                    <title>{"ARTIFEX / Home"}</title>
                    <meta name="description" content={"ARTIFEX (ARTistic Immersion for scientiFic EXploration) is an experimental platform for exploring Exoplanet data."} />
                    <meta property="og:title" content={"Pieter Steyaert / Home"} />
                </MetaTags>
    
    
    return <> 
    {Meta}

    <div >
    <CustomDashboard />
    </div>
    
    </>
}



export default Home;
